(function () {
  const body = document.querySelector('html[data-scheme]');

  cscoDarkMode = {
    init: function (e) {
      this.initMode(e);
      window.matchMedia('(prefers-color-scheme: dark)').addListener((e) => {
        this.initMode(e);
      });

      window.addEventListener('load', () => {
        const toggleBtns = document.querySelectorAll('.header__toggle-scheme');
        toggleBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();

            if ('auto' === body.getAttribute('data-scheme')) {
              if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
                cscoDarkMode.changeScheme('light', true);
              } else if (window.matchMedia('(prefers-color-scheme: light)').matches) {
                cscoDarkMode.changeScheme('dark', true);
              }
            } else {
              if ('dark' === body.getAttribute('data-scheme')) {
                cscoDarkMode.changeScheme('light', true);
              } else {
                cscoDarkMode.changeScheme('dark', true);
              }
            }
          });
        });
      });
    },
    initMode: function (e) {
      let siteScheme = false;
      switch (
        '{{ settings.color_scheme }}' // Field. User’s system preference.
      ) {
        case 'dark':
          siteScheme = 'dark';
          break;
        case 'light':
          siteScheme = 'light';
          break;
        case 'system':
          siteScheme = 'auto';
          break;
      }
      if ('{{ settings.dark_mode_toggle }}') {
        // Field. Enable dark/light mode toggle.
        if ('light' === localStorage.getItem('_color_schema')) {
          siteScheme = 'light';
        }
        if ('dark' === localStorage.getItem('_color_schema')) {
          siteScheme = 'dark';
        }
      }
      if (siteScheme && siteScheme !== body.getAttribute('data-scheme')) {
        this.changeScheme(siteScheme, false);
      }
    },
    changeScheme: function (siteScheme, cookie) {
      body.classList.add('scheme-toggled');
      body.setAttribute('data-scheme', siteScheme);
      if (cookie) {
        localStorage.setItem('_color_schema', siteScheme);
      }
      setTimeout(() => {
        body.classList.remove('scheme-toggled');
      }, 100);
    },
  };
})();

cscoDarkMode.init();

document.addEventListener('shopify:section:load', function () {
  setTimeout(() => {
    cscoDarkMode.init();
  }, 100);
}); 